import { render, staticRenderFns } from "./ScoutMemberComment.vue?vue&type=template&id=1ccbf044"
import script from "./ScoutMemberComment.vue?vue&type=script&lang=js"
export * from "./ScoutMemberComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports